export const computeBasedOnPercent = ({
  priceInCents,
  percentage,
}: {
  priceInCents?: number | null
  percentage?: number | null
}) => {
  const finalPercentage = percentage || 0
  const finalPriceInCents = priceInCents || 0
  return Math.min(
    Math.ceil((finalPercentage * finalPriceInCents) / 100),
    finalPriceInCents,
  )
}
